// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HnTL","top":"styles_top__1E4-K","left":"styles_left___mbMG","description":"styles_description__2ZK4h"};